<div class="header-container">
  <div class="navbar-top-container">
    <div
      class="navbar-top-home-link pointer"
      [routerLink]="profileStartUrl ? [profileStartUrl] : ['/principal']"
    ></div>
    <!-- Navigation bar -->
    <ul class="navbar-top">
      <!-- ANCHOR Client dropdown -->
      @if (sessionProfile == PROFILES.ARSON || sessionProfile == PROFILES.USUARIO_ARSON) {
        <li>
          <app-navbar-top-dropdown
            [type]="'client'"
            [classes]="'fa fa-user-tie fa-fw'"
            [selectorClasses]="'fa fa-user-tie'"
            [title]="'clients'"
            [listLink]="'/clientes/listado'"
            [newLink]="'/clientes/formulario/nuevo'"
            [currentElement]="currentClient"
            [elementList]="clientList"
            [allowList]="
              sessionProfile == PROFILES.ARSON || sessionProfile == PROFILES.USUARIO_ARSON
            "
            [allowNew]="sessionProfile == PROFILES.ARSON"
            [attributeShowed]="'clientName'"
            (dropdownFilterFlag)="dropdownFilter($event.filterValue, $event.type)"
            (updateCurrentElementFlag)="updateCurrentClient($event)"
            (resetSearchBoxFlag)="resetSearchBox($event)"
          ></app-navbar-top-dropdown>
        </li>
      }

      <!-- ANCHOR Entity dropdown -->
      @if (sessionProfile != PROFILES.TELEMEDIDA) {
        <li>
          <app-navbar-top-dropdown
            [type]="'entity'"
            [classes]="SessionDataService.dataProtectionActive() ? '' : 'fa fa-sitemap fa-fw'"
            [selectorClasses]="'fa fa-sitemap'"
            [title]="'entities'"
            [listLink]="'/entidades/listado'"
            [newLink]="'/entidades/formulario/nuevo'"
            [currentElement]="currentEntity"
            [elementList]="entityList"
            [allowList]="
              sessionProfile == PROFILES.ARSON || sessionProfile == PROFILES.USUARIO_ARSON
            "
            [allowNew]="sessionProfile == PROFILES.ARSON"
            [attributeShowed]="'entity'"
            (dropdownFilterFlag)="dropdownFilter($event.filterValue, $event.type, $event.alias)"
            (updateCurrentElementFlag)="updateCurrentEntity($event)"
            (resetSearchBoxFlag)="resetSearchBox($event)"
          ></app-navbar-top-dropdown>
        </li>
      }

      <!-- ANCHOR Agrupation dropdown -->
      @if (sessionProfile != PROFILES.TELEMEDIDA) {
        <li>
          <app-navbar-top-dropdown
            [type]="'agrupation'"
            [classes]="'fa fa-map fa-fw'"
            [selectorClasses]="'fa fa-map'"
            [highlight]="'virtual'"
            [title]="'agrupations'"
            [listLink]="'/agrupaciones/listado'"
            [newLink]="'/agrupaciones/formulario/nuevo'"
            [currentElement]="currentAgrupation"
            [elementList]="agrupationList"
            [allowList]="
              sessionProfile == PROFILES.ARSON ||
              sessionProfile == PROFILES.USUARIO_ARSON ||
              sessionProfile == PROFILES.ADMIN_ENTIDAD ||
              sessionProfile == PROFILES.ADMIN_CLIENTE
            "
            [allowNew]="
              sessionProfile == PROFILES.ARSON ||
              sessionProfile == PROFILES.ADMIN_ENTIDAD ||
              sessionProfile == PROFILES.ADMIN_CLIENTE
            "
            [attributeShowed]="'name'"
            (dropdownFilterFlag)="dropdownFilter($event.filterValue, $event.type, $event.alias)"
            (updateCurrentElementFlag)="updateCurrentAgrupation($event)"
            (resetSearchBoxFlag)="resetSearchBox($event)"
          ></app-navbar-top-dropdown>
        </li>
        @if (
          currentEntity?.euFunded &&
          sessionProfile != PROFILES.ARSON &&
          sessionProfile != PROFILES.USUARIO_ARSON
        ) {
          <div class="sidebar-euro-logos">
            <img src="assets/img/logos/union_europea.png" alt="Logo" />
            <img
              class="sidebar-euro-logos-short"
              src="assets/img/logos/ministerio_transicion.png"
              alt="Logo"
            />
            <img src="assets/img/logos/plan_recuperacion_v.png" alt="Logo" />
          </div>
        }
      }

      <!-- ANCHOR Search box -->
      <li class="navbar-top-search navbar-top-align-left">
        <app-navbar-top-search-navigation></app-navbar-top-search-navigation>
      </li>

      <!-- ANCHOR Search box and help -->
      @if (
        sessionProfile != PROFILES.INSTALADOR &&
        sessionProfile != PROFILES.ADMIN_INSTALLATION &&
        sessionProfile != PROFILES.TELEMEDIDA
      ) {
        <li class="navbar-top-search navbar-top-align-right">
          <app-navbar-top-search-box
            [type]="'search'"
            [currentCupsName]="currentCupsName"
            [meterList]="meterList"
            [cupsList]="cupsList"
            [sessionProfile]="sessionProfile"
            (resetSearchBoxFlag)="resetSearchBox($event)"
            (goToSelectionFlag)="
              $event.cupsSelected ? goToCupsDetail($event.selection) : goToDevice($event.selection)
            "
            (dropdownFilterFlag)="
              dropdownFilter($event.filterValue, $event.type, $event.cupsSelected)
            "
          ></app-navbar-top-search-box>
        </li>
      }

      <!-- ANCHOR User dropdown -->
      <li
        [ngClass]="{
          'navbar-top-align-right':
            sessionProfile == PROFILES.INSTALADOR ||
            sessionProfile == PROFILES.ADMIN_INSTALLATION ||
            sessionProfile == PROFILES.TELEMEDIDA
        }"
      >
        <app-navbar-user-dropdown
          [sessionUserName]="sessionUserName"
          [sessionProfile]="sessionProfile"
          [languageName]="languageName"
          [allowList]="
            sessionProfile == PROFILES.ARSON ||
            sessionProfile == PROFILES.USUARIO_ARSON ||
            sessionProfile == PROFILES.ADMIN_ENTIDAD ||
            sessionProfile == PROFILES.ADMIN_CLIENTE ||
            sessionProfile == PROFILES.ADMIN_AGRUPACION ||
            sessionProfile == PROFILES.INSTALADOR ||
            sessionProfile == PROFILES.ADMIN_INSTALLATION
          "
          (switchLanguageFlag)="switchLanguage($event)"
          (switchNumberFormatFlag)="switchNumberFormat($event)"
          (switchDateFormatFlag)="switchDateFormat($event)"
          (deleteUserLocalSettingsFlag)="deleteUserLocalSettings()"
          (resetMapSettingsFlag)="resetMapSettings()"
          (logoutFlag)="logout()"
          (reloginFlag)="relogin()"
          (updateUserRestrictionsFlag)="updateUserRestrictions($event)"
          (updateUserSuspicionFlag)="updateUserSuspicion($event)"
          (updateUserDataProtectionFlag)="updateUserDataProtection($event)"
          (updateMainPageFlag)="updateUserMainPage($event)"
          [pendingNotifications]="pendingNotifications"
        ></app-navbar-user-dropdown>
      </li>
    </ul>

    <!-- ANCHOR Responsive navigation bar -->
    <ul class="navbar-top-responsive">
      <!-- Logo link -->
      <li class="navbar-logo" [routerLink]="['/principal']">
        <a class="navbar-top-logo">
          @if (logoLoading) {
            <i class="fas fa-spinner fa-pulse"></i>
          }
          <img
            class="navbar-top-logo-mini"
            [hidden]="logoLoading"
            (load)="onLogoLoad()"
            src="{{ navbarLogo }}"
            alt="Logo"
          />
        </a>
      </li>

      <li class="navbar-responsive-datamenu">
        <!-- ANCHOR Current client, entity and agrupation -->
        <div class="navbar-responsive-current">
          <div class="navbar-responsive-current-data">
            @if (sessionProfile == PROFILES.ARSON || sessionProfile == PROFILES.USUARIO_ARSON) {
              <div class="navbar-responsive-current-client">
                @if (!currentClient) {
                  <p class="navbar-top-selected">-</p>
                }
                @if (currentClient) {
                  <p class="navbar-top-selected">
                    {{ currentClient.clientName }}
                  </p>
                }
              </div>
            }
            <div class="navbar-responsive-current-entity">
              @if (!currentClient) {
                <p class="navbar-top-selected">-</p>
              }
              @if (currentClient) {
                <p class="navbar-top-selected">
                  {{ currentEntity?.entity }}
                </p>
              }
            </div>
            <div class="navbar-responsive-current-agrupation">
              @if (!currentClient) {
                <p class="navbar-top-selected">-</p>
              }
              @if (currentClient) {
                <p class="navbar-top-selected">
                  {{ currentAgrupation?.name }}
                </p>
              }
            </div>
          </div>
          <div class="navbar-responsive-current-icon">
            <i class="fa fa-users fa-fw"></i>
            @if (!SessionDataService.dataProtectionActive()) {
              <i class="fa fa-sitemap fa-fw"></i>
            }
            <i class="fa fa-map fa-fw"></i>
          </div>
        </div>

        <!-- Responsive menu -->
        <div class="navbar-responsive-menu" (click)="showResponsiveMenu()">
          <i class="fas fa-bars"></i>
        </div>
      </li>
    </ul>
  </div>

  <!-- ANCHOR Clock and timezone -->
  <div class="navbar-top-clock">
    <!-- Entity totals -->
    @if (currentAgrupation) {
      <div class="navbar-top-clock-data">
        @if (
          sessionProfile != PROFILES.INSTALADOR &&
          sessionProfile != PROFILES.ADMIN_INSTALLATION &&
          sessionProfile != PROFILES.TELEMEDIDA
        ) {
          <div class="navbar-top-clock-entity-totals">
            <app-entity-total-snapshot></app-entity-total-snapshot>
          </div>
        }
        <div>
          <i class="fas fa-calendar-day"></i>
          {{ clockTime?.date != null ? clockTime?.date : "-" }}
        </div>
        <div>
          <i class="fa fa-clock"></i>
          {{ clockTime?.time != null ? clockTime?.time : "-" }}
        </div>
        <div>
          <i class="fas fa-globe"></i>
          {{ currentAgrupation ? currentAgrupation?.timezone : "-" }}
          {{
            sessionProfile == PROFILES.ARSON || sessionProfile == PROFILES.USUARIO_ARSON
              ? "(" + (clockTime?.offset != null ? clockTime?.offset : "-") + ")"
              : ""
          }}
        </div>
        <!-- ANCHOR Weather data -->
        @if (sessionProfile == PROFILES.ARSON) {
          <div class="navbar-top-weather">
            @if (!weatherData) {
              <button type="button" (click)="updateWeatherData()">
                @if (weatherLoading) {
                  <i class="fas fa-spinner fa-pulse"></i>
                }
                @if (!weatherLoading) {
                  <span>{{ "load-weather" | translate }}</span>
                }
              </button>
            }
            @if (weatherData) {
              <div>
                <i class="{{ weatherData.icon }}"></i>
                <span>{{ weatherData.text }}</span>
                <button
                  class="navbar-top-weather-update"
                  [disabled]="!weatherUpdateEnabled"
                  (click)="weatherData = null; updateWeatherData()"
                >
                  <i class="fas fa-sync-alt"></i>
                </button>
              </div>
            }
            <!-- Extra weather data -->
            @if (weatherData) {
              <div class="navbar-top-weather-extra-info">
                <div class="navbar-top-weather-data-container">
                  <div class="navbar-top-weather-data-agrupation">
                    {{ currentWeatherCoords.agrupation }}
                  </div>
                  @if (weatherData.temp) {
                    <div class="navbar-top-weather-data">
                      <div>
                        <i class="fas fa-thermometer-half"></i>
                        <b>{{ "weather-temp" | translate }}:</b>
                      </div>
                      {{ weatherData.temp }}°
                    </div>
                  }
                  @if (weatherData.minTemp) {
                    <div class="navbar-top-weather-data">
                      <div>
                        <i class="fas fa-thermometer-quarter"></i>
                        <b>{{ "weather-min-temp" | translate }}:</b>
                      </div>
                      {{ weatherData.minTemp }}°
                    </div>
                  }
                  @if (weatherData.maxTemp) {
                    <div class="navbar-top-weather-data">
                      <div>
                        <i class="fas fa-thermometer-full"></i>
                        <b>{{ "weather-max-temp" | translate }}:</b>
                      </div>
                      {{ weatherData.maxTemp }}°
                    </div>
                  }
                  @if (weatherData.pressure) {
                    <div class="navbar-top-weather-data">
                      <div>
                        <i class="fas fa-tachometer-alt"></i>
                        <b>{{ "weather-pressure" | translate }}:</b>
                      </div>
                      {{ weatherData.pressure }} hPa
                    </div>
                  }
                  @if (weatherData.humidity) {
                    <div class="navbar-top-weather-data">
                      <div>
                        <i class="fas fa-tint"></i>
                        <b>{{ "weather-humidity" | translate }}:</b>
                      </div>
                      {{ weatherData.humidity }}%
                    </div>
                  }
                  @if (weatherData.clouds) {
                    <div class="navbar-top-weather-data">
                      <div>
                        <i class="fas fa-cloud"></i>
                        <b>{{ "weather-clouds" | translate }}:</b>
                      </div>
                      {{ weatherData.clouds }}%
                    </div>
                  }
                  @if (weatherData.sunrise) {
                    <div class="navbar-top-weather-data">
                      <div>
                        <i class="fas fa-sun"></i>
                        <b>{{ "weather-sunrise" | translate }}:</b>
                      </div>
                      {{ weatherData.sunrise }}
                    </div>
                  }
                  @if (weatherData.sunset) {
                    <div class="navbar-top-weather-data">
                      <div>
                        <i class="fas fa-moon"></i>
                        <b>{{ "weather-sunset" | translate }}:</b>
                      </div>
                      {{ weatherData.sunset }}
                    </div>
                  }
                </div>
                <div class="navbar-top-weather-source">OpenWeather®</div>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>

  @if (showResponsiveMenuFlag && hideDesktopMenus) {
    <app-navbar-responsive
      (showResponsiveMenuFlag)="showResponsiveMenu()"
      (languageChangeFlag)="switchLanguage($event)"
      (logoutFlag)="logout()"
      [meterList]="meterList"
      [cupsList]="cupsList"
      [currentCupsConf]="currentEntityCupsConf"
      [currentCupsName]="currentCupsName"
      [sessionProfile]="sessionProfile"
      [sessionUserName]="sessionUserName"
      [currentClient]="currentClient"
      [currentEntity]="currentEntity"
      [currentAgrupation]="currentAgrupation"
      [clientList]="clientList"
      [entityList]="entityList"
      [agrupationList]="agrupationList"
      (resetFilterFlag)="resetSearchBox($event)"
      (searchSelection)="
        $event.cupsSelected ? goToCupsDetail($event.selection) : goToDevice($event.selection)
      "
      (dropdownFilterFlag)="dropdownFilter($event.filterValue, $event.type, $event.cupsSelected)"
      (updateAgrupationFlag)="updateCurrentAgrupation($event)"
      (updateEntityFlag)="updateCurrentEntity($event)"
      (updateClientFlag)="updateCurrentClient($event)"
      (deleteUserLocalSettingsFlag)="deleteUserLocalSettings()"
      (resetMapSettingsFlag)="resetMapSettings()"
      [pendingNotifications]="pendingNotifications"
    ></app-navbar-responsive>
  }
</div>
